module.exports = __webpack_public_path__ + "banquet/components/AccountSettingsModal/images/large_close.01e4476537395ec53530c64b1fa1c1db.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettingsModal/images/large_close.svg
// module id = 1648
// module chunks = 1